<template>
  <svg
    class="code"
    xmlns="http://www.w3.org/2000/svg"
    shape-rendering="geometricPrecision"
    text-rendering="geometricPrecision"
    image-rendering="optimizeQuality"
    fill-rule="evenodd"
    clip-rule="evenodd"
    viewBox="0 0 640 640"
  >
    <path
      fill-rule="nonzero"
      d="M234.227 122.352h-89.576L.001 312.618 144.65 502.86h89.576L89.576 312.618l144.651-190.266zm171.557 0h89.576L640 312.618 495.36 502.86h-89.576l144.651-190.242-144.651-190.266zm-40.3-66.639l31.016 7.229c4.878 1.122 7.938 6.047 6.804 10.913L286.137 577.471c-1.146 4.867-6.048 7.926-10.926 6.804l-31.016-7.229c-4.878-1.122-7.937-6.047-6.803-10.913L354.559 62.517c1.146-4.867 6.06-7.926 10.925-6.804z"
    />
  </svg>
</template>

<script>
export default {
  name: 'Code',
};
</script>

<style scoped>
.code {
  display: block;
}
</style>
